// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";

// 🌟 GLOBÁLNÍ STYLY
import "./index.css";

// 🌟 NUTNÉ PRO REACT-DAY-PICKER v9 !!!
import "react-day-picker/dist/style.css";

import App from "./App"; // načte App.js

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Necháváme bez StrictMode – ulehčí debugging useEffect a stačí to
  <App />
);
